export default {
  taskTypes: {},
  taskGroups: {},
  taskTemplates: {},
  taskOperations: [],
  recentlyCreatedTaskGroups: {}
}
